// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:16:21

export default {
  "id": "block-puzzle-travel",
  "slug": "block-puzzle-travel",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9bb63ed68fb248299c4b8d22c814ef1e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9bb63ed68fb248299c4b8d22c814ef1e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Block Puzzle Travel",
      "description": "The goal of the game is to destroy as many blocks as possible. By doing so, you will earn points for completing the game perfectly.\nBy solving puzzles, you train your attention, thought processes and brain.\nIn this game you have to achieve the maximum result, and pass all levels.",
      "instructions": "Destroy diamond blocks, earn points, pass level after level until you pass the game completely. The more blocks destroyed in one turn, the more points the player gets.\n",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "cute",
        "logic",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "方块拼图旅行",
      "description": "游戏目标是尽可能摧毁更多方块。通过完美完成游戏，你将获得积分。\n通过解决谜题，你将训练你的注意力、思维过程和大脑。\n在这款游戏中，你必须取得最高分，并通过所有关卡。",
      "instructions": "摧毁钻石方块，赚取分数，逐级通关直至完成整个游戏。一次性摧毁的方块越多，玩家获得的分数越多。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "可爱",
        "逻辑",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "堵塊拼圖旅行",
      "description": "遊戲的目標是盡可能摧毀多塊積木。通過這樣做，你將為完美完成遊戲獲得分數。\n通過解謎，你可以鍛煉你的注意力、思維過程和腦力。\n在這款遊戲中，你必須達到最高分數，並通過所有關卡。",
      "instructions": "摧毀鑽石塊，獲得分數，通過一關又一關，直到完全通過遊戲。在一次回合中摧毀的塊數越多，玩家獲得的分數就越多。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "可愛",
        "邏輯",
        "俄羅斯方塊"
      ]
    },
    "zh-HK": {
      "title": "塊塊遊戲旅遊",
      "description": "遊戲的目標是破壞盡可能多的方塊。透過這樣做，你將為完美完成遊戲而獲得分數。\n通過解謎，你會訓練你的注意力、思維過程和腦力。\n在這個遊戲中，你必須達到最高成績，並通過所有關卡。",
      "instructions": "摧毀鑽石塊，積分，逐級通過，直至遊戲全勝。一回合內摧毀的塊數越多，玩家獲得的分數就越多。",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "可愛",
        "邏輯",
        "俄罗斯方块"
      ]
    },
    "ja": {
      "title": "ブロックパズルトラベル",
      "description": "ゲームの目的はできるだけ多くのブロックを破壊することです。これにより、完璧にゲームを終えることでポイントを獲得できます。\nパズルを解くことで、注意力、思考プロセス、脳を鍛えます。\nこのゲームでは、最高の結果を達成し、すべてのレベルをクリアする必要があります。",
      "instructions": "ダイヤモンドブロックを破壊し、ポイントを獲得し、レベルをクリアしてゲームを完全にクリアしましょう。一ターンで破壊したブロックが多いほど、プレイヤーは多くのポイントを獲得します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "可愛い",
        "ロジック",
        "テトリス"
      ]
    },
    "ko": {
      "title": "블록 퍼즐 트래블",
      "description": "게임의 목표는 가능한 많은 블록을 파괴하는 것입니다. 이를 통해 완벽하게 게임을 완료하여 점수를 얻을 수 있습니다.\n퍼즐을 해결함으로써 주의력, 사고력 및 뇌를 훈련할 수 있습니다.\n이 게임에서는 최대 결과를 달성하고 모든 레벨을 통과해야 합니다.",
      "instructions": "다이아몬드 블록을 파괴하여 점수를 챙기고, 레벨을 통해 모든 게임을 완료해 나가세요. 한 턴에 파괴한 블록이 많을수록 플레이어는 더 많은 점수를 얻습니다.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "취급",
        "논리",
        "테트리스"
      ]
    },
    "fr": {
      "title": "Puzzle Block Voyage",
      "description": "L'objectif du jeu est de détruire le plus grand nombre de blocs possible. En le faisant, vous gagnez des points pour compléter le jeu parfaite-\nment.\nEn résolvant des puzzles, vous entraînez votre attention, votre pensée et votre cerveau.\nDans ce jeu, vous devez atteindre le résultat maximum et passer tous les niveaux.",
      "instructions": "Déstroys les blocs de diamant, gagne des points, passez de niveau en niveau jusqu'à ce que vous ayez terminé le jeu complètement. Plus de blocs détruits en une seulemanche, plus de points le joueur reçoit.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "mignon",
        "logique",
        "Tetris"
      ]
    }
  }
};
